export default function getIds(array: { id: string | null }[]): string[] {
  //@ts-ignore ts doesnt understand that filter filters null
  return array
    .filter(v => !!v)
    .map(instance => instance && instance.id);
}
